var exports = {
  "kL": "xfd349460--3447f1--container",
  "sx": "xfd349460--3447f1--hovered-block",
  "_8": "xfd349460--3447f1--img",
  "Qs": "xfd349460--3447f1--content",
  "cL": "xfd349460--3447f1--builder",
};

module.exports = exports;
